import {RequestModel} from "../../../request";
import {REQUEST} from "../../../requests.consts";
import {shareState} from "../../../../../app/share-state";

export class GetRequestOtherUserGamesModel extends RequestModel {
  constructor(requestParams) {
    super(REQUEST.CATEGORY.games, REQUEST.ACTION.GAMES.getOtherUserGames, requestParams, false, true, true, false);

    this.apiEnvironment = shareState.environment.baseUrl;
    this.method = REQUEST.METHOD_TYPE.get;
  }
}
